import React from 'react';

const CamraIcon = (props) => {
  return (
    <svg
      viewBox="0 0 89 78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="86.16px"
      height="75.42px"
      {...props}
    >
      <path
        d="M37.5195 9.13916H52.5107C53.3942 9.13916 54.1731 9.71874 54.4268 10.5649L56.5205 17.5542L56.7344 18.2671H70.7627C74.0763 18.2672 76.7626 20.9535 76.7627 24.2671V55.1909C76.7626 58.5044 74.0762 61.1908 70.7627 61.1909H19.4668C16.1532 61.1909 13.4669 58.5045 13.4668 55.1909V24.2671C13.4669 20.9534 16.1531 18.2671 19.4668 18.2671H33.2969L33.5098 17.5542L35.6035 10.5649C35.8413 9.77156 36.541 9.21275 37.3555 9.146L37.5195 9.13916Z"
        stroke="#211F59"
        strokeWidth={2}
        strokeLinejoin="round"
      />
      <circle
        cx="45.1146"
        cy="39.2389"
        r="12.2721"
        stroke="#211F59"
        strokeWidth={2}
      />
      <path d="M1 15.233V1H14.9085" stroke="#211F59" strokeWidth={2} strokeLinecap="round" />
      <path d="M87.1584 15.233V1H73.2499" stroke="#211F59" strokeWidth={2} strokeLinecap="round" />
      <path d="M1 62.1908V76.4238H14.9085" stroke="#211F59" strokeWidth={2} strokeLinecap="round" />
      <path d="M87.1584 62.1908V76.4238H73.2499" stroke="#211F59" strokeWidth={2} strokeLinecap="round" />
    </svg>
  );
};

export default CamraIcon;
